export default __webpack_public_path__ + "static/media/src_jquery_mobile_1.1bc33729.jpg";